var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ProjectRubricsPure',{attrs:{"message-view":_vm.messageView,"project":_vm.project,"rubrics":_vm.rubrics}})}
var staticRenderFns = []

export { render, staticRenderFns }